import { render, staticRenderFns } from "./addTeam.vue?vue&type=template&id=2ad15dcc"
import script from "./addTeam.vue?vue&type=script&lang=js"
export * from "./addTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports